import { Spin, Table } from 'antd';
import en_us from 'rc-pagination/lib/locale/en_US';
import zh_cn from 'rc-pagination/lib/locale/zh_CN';
import { ENGLISH } from '../../utils/constants';
import { TriangleWrap } from '../Widgets';

export default ({ intl, dispatch, loading, customReport }) => {
  const {
    crName,
    total,
    pageNo,
    sqlResult,
    pageSizeShow: pageSize
  } = customReport;

  // 查询结果的所有key值
  const keys = [];
  if (sqlResult.length > 0) {
    let hasId = false;
    for (const key in sqlResult[0]) {
      if (key.toLowerCase() === 'id') {
        hasId = true;
      } else if (key.toLowerCase() !== 'crunikey') {
        keys.push(key);
      }
    }
    keys.sort();
    // 如果有id字段，放在第一列
    if (hasId) {
      keys.unshift('id');
    }
  }

  sqlResult.forEach(sr => {
    // 给每条记录增加一个唯一的key值
    sr['crUniKey'] = Math.random();
  });

  const colWidth = 194;
  const columns = keys.map(k => {
    return {
      title: k,
      dataIndex: k,
      width: colWidth,
      key: k,
      render: text => (
        <span className="result-cell" title={text}>
          {text}
        </span>
      )
    };
  });

  const scrollObj = {
    x: keys.length > 8 ? colWidth * keys.length : false
  };

  const pagination = {
    total,
    onChange: page => {
      dispatch({ type: 'customReport/setState', payload: { pageNo: page } });
      dispatch({ type: 'customReport/showPage' });
    },
    pageSize,
    current: pageNo,
    locale: intl.formatMessage({ id: 'locale' }) === ENGLISH ? en_us : zh_cn
  };

  return (
    <div className="container-left sys-config-container">
      <div className="container-user">
        <Spin spinning={loading} size="large">
          <div className="container-desk">
            <div className="user-information">
              <div className="user-right">
                <div className="right-title">
                  <div className="tabs-container">{crName}</div>
                  <div className="report-div export_btn_div">
                    <div
                      className="report_button button_ghost btn_reset"
                      onClick={() => {
                        dispatch({ type: 'customReport/exportPage' });
                      }}
                    >
                      导出
                    </div>
                  </div>
                  <TriangleWrap className="children-wrap custom-report">
                    <div className="custom-report-show only-show">
                      <Table
                        rowKey={record => record.crUniKey}
                        columns={columns}
                        dataSource={sqlResult}
                        pagination={pagination}
                        scroll={scrollObj}
                      />
                    </div>
                  </TriangleWrap>
                </div>
              </div>
            </div>
          </div>
        </Spin>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/report/CustomReportShow.js